import React from 'react';
import { Navigate } from 'react-router-dom';

// Should be used inside all JSX components and pages
export function navigateToErrorPage(status = 400) {
  const url = `/error?status=${status}`;
  return <Navigate to={url} replace />;
}

// Below is helper methods to use with react router loader/actions and Await Suspense
function createErrorResponseWithStatusCode(statusCode) {
  const statusTexts = {
    400: 'Bad Request',
    401: 'Not Authorized',
    403: 'Forbidden',
    404: 'Not Found',
    500: 'Internal Server Error',
    503: 'Service Unavailable',
    // Add more status codes and messages as needed
  };

  const statusText = statusTexts[statusCode] || 'Unknown Error';

  return new Response(statusText, {
    status: statusCode || 400,
    statusText: statusText,
  });
}

// Should only be used in loaders and actions that are NOT deffered, otherwise use throwErrorWithStatusCode
// is not captured by the error boundary
// Again this should only be used in loaders and actions that are NOT deffered.
export function throwErrorWithStatusCode(statusCode) {
  throw createErrorResponseWithStatusCode(statusCode);
}
